module.exports = __webpack_public_path__ + "static/media/relax.816ade2c.svg";